import React from 'react';
import PropTypes from 'prop-types';
import './YesNoInput.scss';
import TextAreaInput from '../TextAreaInput';

function MQInput({
  id, value, currentValue, onInputChange, title, labelError,
}) {
  const isSelected = currentValue !== null && currentValue === value;
  const inputId = `${id}-${value}`;

  return (
    <span className="input-question body-text-2">
      <input
        className="yes-no-input"
        type="radio"
        id={inputId}
        checked={isSelected}
        onChange={onInputChange}
        value={value}
      />
      <label htmlFor={inputId} className={`body-text-2 normal-weight ${labelError && 'with-error'}`}>
        { title || value }
      </label>
    </span>
  );
}

MQInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  currentValue: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  labelError: PropTypes.bool,
};

MQInput.defaultProps = {
  currentValue: null,
  title: null,
  labelError: false,
};

const isDescEmpty = (desc) => !desc || !desc.trim();

function YesNoInput(props) {
  const {
    id,
    className,
    onAnswerChange,
    value,
    showDescriptionInput,
    onDescAnswerChange,
    descValue,
    errors,
    reverseAnswer,
    exampleText,
    textPromptClass,
    textAreaPrompt,
    yesNoQuestion,
    labelError,
  } = props;

  const possibleAnswers = reverseAnswer ? ['No', 'Yes'] : ['Yes', 'No'];

  const placeholder = value === possibleAnswers[1] ? 'Tell us more... (required)' : 'Tell us more...';

  let error = null;

  // If user starts typing or chooses the non required value, remove the error from input
  if (showDescriptionInput && isDescEmpty(descValue) && value === possibleAnswers[1]) {
    error = errors[`${id}_desc`];
  }

  return (
    <div className={`yes-no-input-container ${className}`}>
      {yesNoQuestion
        && <span className="pr-10">{yesNoQuestion}</span>}
      <div className="ms-2">
        { possibleAnswers.map((answer) => (
          <MQInput
            id={id}
            key={answer}
            value={answer}
            currentValue={value}
            onInputChange={(e) => onAnswerChange(e.target.value)}
            labelError={labelError}
          />
        ))}
      </div>

      { showDescriptionInput && value === possibleAnswers[1]
        && (
        <div className="mt-15">
          {error && error === 'field' && (
          <div className="body-text-2 medium-weight with-error-text mt-2 mb-2">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            Required!
          </div>
          )}
          <TextAreaInput
            placeholder={placeholder}
            value={descValue}
            error={error}
            onAnswerChange={onDescAnswerChange}
            exampleText={exampleText}
            textPromptClass={textPromptClass}
            textAreaPrompt={textAreaPrompt}
          />
        </div>
        )}
    </div>
  );
}

YesNoInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOf(['Yes', 'No', null]),
  className: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  showDescriptionInput: PropTypes.bool,
  onDescAnswerChange: PropTypes.func,
  descValue: PropTypes.string,
  errors: PropTypes.shape({}),
  reverseAnswer: PropTypes.bool,
  exampleText: PropTypes.string,
  textPromptClass: PropTypes.string,
  textAreaPrompt: PropTypes.string,
  yesNoQuestion: PropTypes.string,
  labelError: PropTypes.bool,
};

YesNoInput.defaultProps = {
  className: null,
  value: null,
  showDescriptionInput: false,
  onDescAnswerChange: null, // required if showDescriptionInput is true
  descValue: '', // required if showDescriptionInput is true
  errors: {},
  reverseAnswer: false,
  exampleText: null,
  textPromptClass: '',
  textAreaPrompt: 'Tell us more about that.',
  yesNoQuestion: null,
  labelError: false,
};

export default YesNoInput;
